export const ANSWER_TYPE = {
  text: 0,
  file: 1
};
